import {Link} from "react-router-dom";
import logo from '../../images/logo.png'

export default function Footer() {
    return (
        <footer className="w-full">
            <div className="flex flex-col md:flex-row flex-1 p-4 justify-around items-center py-10 bg-gray-100">
                <div className="flex flex-1 max-w-[300px] flex-col  items-center gap-2 mx-4">
                    <Link className="w-full justify-start flex flex-row flex-1 items-center" to="/">
                        <img src={logo} alt="Logo" className="flex  h-14"/>
                        <div className="ml-2 flex flex-col">
                            <p className="text-xl font-extrabold font-bowlby-one uppercase text-slate-700"> Gold
                                Phase</p>
                            <p className="font-bold text-md font-roboto text-gray-600"> Medical
                                Foundation</p>
                        </div>
                    </Link>
                    <p className="justify-start flex flex-1 items-center text-slate-600">
                        GoldPhase Medical Foundation provides affordable healthcare to underserved communities through
                        medical camps and outreach programs
                    </p>
                </div>

                <div className="flex flex-1 max-w-[300px] flex-col justify-start items-center gap-2">
                    <p className="flex flex-1 w-full font-extrabold text-2xl font-playfair-display">News Letter</p>
                    <p className="text-slate-600">you can trust us. we don't like to spam you.</p>
                    <div className="flex flex-col md:flex-row">
                        <input type="email" name="email"
                               className="px-4 py-2 border-2 rounded-l-md hover:border-yellow-500"
                               placeholder="Enter your Email"/>
                        <button
                            className="px-4 py-2 bg-yellow-600 hover:bg-white text-white hover:text-yellow-600 border-yellow-600 border-2">Subscribe
                        </button>
                    </div>
                </div>


            </div>
            <div className="flex flex-1 p-4 justify-around items-center border-t">
                <p className="!text-xs text-md font-serif">© 2024 GoldPhase Medical Foundation.</p>
                <div className="flex flex-row gap-4">
                    <Link to="/privacy-policy" className="!text-xs text-md font-serif underline hover:text-yellow-600">
                        Privacy Policy.</Link>
                    <Link to="/terms-of-use" className="!text-xs text-md font-serif underline hover:text-yellow-600">
                        Terms of Use.</Link>
                </div>

            </div>
        </footer>
    )
}